import * as React from "react";

const SvgIcon: React.FC<React.SVGProps<SVGElement>> = ({ width = 30, height = 30 }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 30 30"
    >
        <path fill="url(#pattern0_1_205)" d="M0 0h30v30H0z"></path>
        <defs>
            <pattern
                id="pattern0_1_205"
                width="1"
                height="1"
                patternContentUnits="objectBoundingBox"
            >
                <use xlinkHref="#image0_1_205" transform="scale(.01)"></use>
            </pattern>
            <image
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE30lEQVR4nO3dS28cRRAH8IYDIJ4CpHCE8DryEQhIgEy8XWuE9gKRAIkvACKABGglV60NRAJxjTiB4MDrgIRNMM5WrWOTiCgnRATfAISCCOF9aNTemHDweGd2Z7cfU3+pT5Z3x/Vzdc+Mp9fGaDQajUaj0WgSSae7dVOrNzgAxJ1YRnuRD9rel7eYJmVhaXA3kHwMJP8AiYttWOK/LPELpglpoTxkkc+HLjqUGnzE5N4Z6WBI/igW5ZPwBRZF2VnAY10zoMSwxG+YnAI9vj90UUFRLqVF8mjogsJeA+ULi3yqMWvK8Dw/gsJT4fig8+raDZb4ZCOmrxRAjF/rmoKSCkhjUFICaQRKaiDZo6QIkjVKqiDZoqQMkiVK6iDZoeQAkhVKLiDZoOQEkgVKbiDJo+QIkjRKriDJouQM8h9Kib+nRPM0S/QgyCcm/RlLoaD8+Uh3c58JndhBLPLvB3H91lmgtIgfNqETOwgMUU7NBoU7JnRSAIHh+MNPX35NmWzwMQWhVIZ2iAuPoCAufOEVxIUvtoK48AVWEBe+qAoSQSFFQcIXTxQkfMFEQcIXSRQkfGFEQcIXQyIYeuvEhUdQEBe+8AriwhdbQVz4AiuIC19UBYmgkKIg4YsnChKqUJbkW0u8bEmetChPAMrLQPK+JTnjn0rRDpndb+wv7R4/Zpy7rOghjW7XXW5R9vvP02qhPAfEb1viTUA+N8b76VMnUNQVyOdtb3DPJE/UzC9v3G6RnwfkHxWEJpymeoNDpqYsLK3dbFGOa4fQmBjI3/mpyNSYA93+VUCyqlMWjQXyuplCOt1vrrAon+oaQhVRsP+UmVK2OwVlRRd1Kg/SJnm6qKBA8r0lPg0k7/gtBG1i6xfvKlNccafoWZYruO54paiYFmVQ8D2/WpSvAfldQHkRXjtxXfVOURC3+xoi7xWCkBwtN+3J1lz35PXVOkVBXMFv+5miIsLi4Jnya1FVFAVxBYvrb0VrgsX+XLUThCooCuKKT31l/27F8xt3Kp9GE2+OQpl7a+XKBVy/w4ROrBt2WgXby3znAMqFyq9ZolOiSKwggPxs0TH7NWa810wAJVYQS3K06Jj9Wdj40JGjxAoCJBt7HPNLk2GPXlOCJVYQi/JT0TH7YgLKVxO9R6ydEisI+Fsoy/3bGocSMwiQHB6173xSlOimr5hBLPEP/r83TBslqk6JGQSGZ1tr/qKtMSixg8BwrPq7s3v9HNmsKYmAuMagJATiGoGSGIjLHiVBEJc1SqIgLluUhEHcrFD8QxXzyxs3Kgg1ECXxDnHDYslnoy4e65m++E0FoZIoyJ+P6pQHjxy7xhLLWOgog063f62CUHiUmWEk8Y8laWrT11ZJjOOt7umrzazSxv59oYsIkXbKTDtjJ/7MwSL/HbqIEFmnlOkM/3X/ufG1X6cA8kehCwgRoZTG2NkEVPfF4/wi3+X384UuIESAUhnj0litdZMRYP+BXFEAZaUMip9+xsTYeZ/HTZ2xS/07LfGHOa4pUAJlVPbE2B68bqa10APKvcOr+HzGwgTP7o7G2L6SP1evhGZ8jGEXXtj9FTSzx7h4A7K+d9bsGn9Dsa7nyDQ1pPRtFpSzM73FYpqOQnt86ADKWb8TOPRxNipd/yE3vcEhf2prSX722+62d/2SHP5/Z/wLSF+Y2+L8w6AAAAAASUVORK5CYII="
                id="image0_1_205"
                width="100"
                height="100"
                preserveAspectRatio="none"
            ></image>
        </defs>
    </svg>
);

export default React.memo(SvgIcon);
